import axios from 'axios'

const endpoint = '/api/v1/notifications'

// Define notifications module
const notifications = {
  state: {
    data: [],
  },
  getters: {
    getNotifications: state => {
      return state.data
    }
  },
  mutations: {
    storeNotifications (state, payload) {
      state.data = payload
    },
    readNotifications (state, payload) {
      let index = state.data.findIndex(i => i.id === payload)
      state.data.splice(index, 1)
    }
  },
  actions: {
    async getNotificationsCollection ({ commit }) {
      const response = await axios.get(endpoint)
      if (await response.status === 200) {
        commit('storeNotifications', response.data.data)
      }
    },
    async storeNotifications ({ commit }, payload) {
      const response = await axios.post(endpoint, payload)
      if (await response.status === 201) {
        commit('storeNotifications', await response.data.data)
      }
    },
    async readNotifications ({ commit }, payload) {
      const response = await axios.put(`${endpoint}/${payload}`, {
        id: payload,
        read: true
      })
      if (await response.status === 202) {
        commit('readNotifications', payload)
      }
    }
  }
}

// Export the notifications module
export default notifications
